import * as z from 'zod';
export const env = z.object({
    NODE_ENV: z.enum(['development', 'production']),
    VUE_APP_VERSION: z.string(),
    VUE_APP_VERSION_NAME: z.string(),
    VUE_APP_OVERRIDE_PORTAL_URL: z.string().optional(),
    HOMEDRIVE: z.string().optional(),
    HOMEPATH: z.string().optional(),
    IS_ELECTRON: z.boolean().optional(),
    BASE_URL: z.string().optional()
}).parse(process.env);
